import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { PageHeaderComponent } from '@libs/common/components';
import { IconComponent } from '@libs/components/icons';
import { ProductBundleModel } from '@libs/shop/models';
import {
  ProductBundleMaxOrderCountLabelComponent,
  ProductBundleValidToLabelComponent,
} from '../../catalog';
import { AddToCartComponent } from '../../elements';
import { ProductDetailBundleItemListComponent } from '../product-detail-bundle-item-list';
import { ProductDetailBundlePricesComponent } from '../product-detail-bundle-prices';
import { ProductDetailFormBaseComponent } from '../product-detail-form-base.component';

@Component({
  selector: 'ui-product-detail-bundle-form',
  imports: [
    AddToCartComponent,
    ProductDetailBundleItemListComponent,
    ProductDetailBundlePricesComponent,
    IconComponent,
    ProductBundleValidToLabelComponent,
    ProductBundleMaxOrderCountLabelComponent,
    PageHeaderComponent,
  ],
  templateUrl: './product-detail-bundle-form.component.html',
  styleUrls: ['../product-detail-form-base.component.scss', './product-detail-bundle-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDetailBundleFormComponent extends ProductDetailFormBaseComponent {
  public bundle: InputSignal<ProductBundleModel> = input.required();
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  public isSapBundle: Signal<boolean> = computed(() => (['reimbursement', 'advantage']).includes(this.product().bundleType!));

  public maxOrderCountReached: Signal<boolean> = computed(() => {
    if (this.isSapBundle()) {
      return false;
    }

    const maxOrderCount: number | undefined = this.bundle().maxOrderCount;

    if (maxOrderCount === undefined) {
      return false;
    }

    return this.bundle().currentOrderCount >= maxOrderCount;
  });

  public maxOrderAmount: Signal<number | undefined> = computed(() => {
    const maxOrderCount: number | undefined = this.bundle().maxOrderCount;

    if (maxOrderCount === undefined) {
      return undefined;
    }

    return maxOrderCount - this.bundle().currentOrderCount;
  });
}
